import React from 'react';
import { components, OptionProps } from 'react-select';
import { Avatar } from '@producer/ui-kit';

import { getNameInitials } from '../../../../lib/utils/get-name-initials';

import styles from './avatar-select-option.module.scss';

export type AvatarOption = {
  value: string;
  avatarSrc: string;
  label: React.ReactNode;
  subtitle?: string;
  suffix?: string;
  isNew?: boolean;
  disabled?: boolean;
};

type AvatarSelectOptionProps = OptionProps<AvatarOption>;

export const AvatarSelectOption: React.FC<AvatarSelectOptionProps> = ({ data, ...props }) => {
  const { label, subtitle, suffix } = data;

  const avatarInitials = typeof label === 'string' ? getNameInitials(label) : '';

  return !data.isNew ? (
    <components.Option {...props} data={data}>
      <div className={styles['container']} data-disabled={!!data.disabled}>
        <div className={styles['left']}>
          <Avatar size="medium" src={data.avatarSrc} initials={avatarInitials} theme="dark" />

          <div className={styles['text-container']}>
            <p className={styles['title']}>{label}</p>

            {subtitle && <span className={styles['subtitle']}>{subtitle}</span>}
          </div>
        </div>

        {suffix && (
          <p className={styles['title']} data-capitalize="true">
            {suffix}
          </p>
        )}
      </div>
    </components.Option>
  ) : null;
};
